import { useCallback } from 'react';
import isNull from 'lodash/isNull';
import omitBy from 'lodash/omitBy';
import type { NavigateFunction } from 'react-router';
import { ratesFilter } from 'libs';

const removeFilter = (value: unknown) => isNull(value) || value === false || value === '';

const useRateFilters = ({
  location,
  navigate,
  onClear,
}: {
  location: { pathname: string; search: string };
  navigate: NavigateFunction;
  onClear?: () => void;
}) => {
  const processFiltersChange = useCallback(
    (filters = {}) => {
      const newFilters = omitBy(filters, removeFilter);

      delete newFilters.sort;

      navigate(
        {
          pathname: location.pathname,
          search: ratesFilter.stringify(newFilters),
        },
        { replace: true }
      );
    },
    [location.pathname, navigate]
  );

  const onFilterClear = useCallback(() => {
    onClear?.();
    processFiltersChange();
  }, [onClear, processFiltersChange]);

  const onFilterChange = useCallback(
    (newFilters?: Record<string, unknown>) => {
      const currentFilters = ratesFilter.parse(location.search);
      processFiltersChange({ ...currentFilters, ...newFilters });
    },
    [location.search, processFiltersChange]
  );

  return { onFilterChange, onFilterClear };
};

export default useRateFilters;
